import { createSlice } from "@reduxjs/toolkit";


const historySlice = createSlice({
    name: 'history',
    initialState: {
        loading: false,
        listHistory: [],
    },
    extraReducers: {
        //get invoice
        // [getCart.pending]: (state, action) => {
        //     state.loadingCart = true
        // },
        // [getCart.fulfilled]: (state, { payload }) => {
        //     state.loadingCart = false
        //     console.log(payload.data.lines, 'cart')
        //     state.cartList = payload.data.lines
        //     state.cartAllData = payload.data
        // },
        // [getCart.rejected]: (state, action) => {
        //     state.loadingCart = false
        // },
    }

})

export default historySlice.reducer